import type { SVGProps } from 'react'

const EnhancedDataIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    {...props}
  >
    <ellipse cx="30" cy="30" rx="30" ry="30" fill="currentColor" />
    <path
      d="M40.6296 35.1988C39.8608 37.0167 38.6585 38.6186 37.1277 39.8645C35.5968 41.1104 33.7841 41.9624 31.8479 42.3458C29.9118 42.7293 27.9112 42.6326 26.021 42.0643C24.1308 41.496 22.4087 40.4733 21.005 39.0856C19.6014 37.6979 18.5591 35.9875 17.9692 34.104C17.3794 32.2204 17.2599 30.2211 17.6212 28.2807C17.9825 26.3402 18.8137 24.5179 20.042 22.9729C21.2704 21.4279 22.8585 20.2074 24.6675 19.418"
      stroke="#0066FF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M39.5833 30.5013C40.6879 30.5013 41.6002 29.5999 41.4182 28.5104C41.2676 27.609 41.0149 26.7255 40.6635 25.8772C40.0563 24.4112 39.1662 23.0791 38.0442 21.9571C36.9222 20.8351 35.5901 19.945 34.1241 19.3378C33.2758 18.9864 32.3923 18.7337 31.4909 18.5831C30.4014 18.4011 29.5 19.3134 29.5 20.418V28.5013C29.5 29.6059 30.3954 30.5013 31.5 30.5013H39.5833Z"
      stroke="#0066FF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default EnhancedDataIcon
